import React from 'react';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
import Dialog from '../../Services/Common/Dialog';
import IndexedDb from '../../Services/IndexedDb/IndexedDb';
/** Components Import */
import Mm10050View from '../../Views/Manufacture/MM10050';
import Snackbar from '../../Components/Snackbar';

function MM10050(props) {
    const [snackbars, setSnackbars] = React.useState({
        toggle: false,
        type: '',
        message: '',
    });
    const [inputs, setInputs] = React.useState({
        comboList: [],
        plantCd: '',
        comboValue: '',
        itemCd: '', //품목코드
        itemNm: '', //품목명
        itemType: '', //품목타입
        itemBomYn: '', //bom여부
        plantCd: '',
        createId: '', //등록자
        updateId: '', //수정자
        itemStdAmt: '', //품목단가
        copyItemList: [], // 복사품목 리스트
        copyItemCd: '', //카피품목코드
    });

    const [checkPlantCd, setCheckPlantCd] = React.useState('');
    const [bomStdAmt, setBomStdAmt] = React.useState('');
    const [lanData, setLanData] = React.useState([]);
    const [rowData, setRowData] = React.useState([]);
    const [rowData1, setRowData1] = React.useState([]);
    const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
    const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
    const [changedRowData, setChangedRowData] = React.useState([]);
    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [changedRowData1, setChangedRowData1] = React.useState([]);
    const [saveItemCd, setSaveItemCd] = React.useState('');
    const [savePlantCd, setSavePlantCd] = React.useState('');
    const [bomYn, setBomYn] = React.useState('');
    const [checkInputs, setCheckInputs] = React.useState({
        itemCd: '',
        itemNm: '',
        whCd: 'WH_IN_01',
        itemQty: 0,
        plantCd: 'P100',
        comboList: [],
        comboInwh: [], //창고
        comboWhCd: [], //재고이동 안 창고
        comboMoveWhCd: [], //재고이동 안 이동창고
    });
    const [checkInputs1, setCheckInputs1] = React.useState({
        value1: '',
        value2: '',
        value3: '',
        itemType: '',
    });
    const [whType, setWhType] = React.useState([]); //창고타입 콤보박스
    React.useEffect(() => {
        window.addEventListener('error', (e) => {
            if (
                e.message === 'ResizeObserver loop limit exceeded' ||
                e.message === 'ResizeObserver loop completed with undelivered notifications.'
            ) {
                const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client- overlay-div');
                const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        });
        SearchLogic();
    }, []);

    //아이템 조회(상단그리드)
    const SearchLogic = async () => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        let getLanData = [];
        let getRowData = [];
        let getComboData = [];
        let getComboData1 = [];
        let getComboData2 = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);

            //창고코드 콤보박스
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh, {
                whCd: 'string',
            }).then((result) => {
                let data = result.data;
                for (let i = 0; i < data.length; i++) {
                    getComboData2.push({
                        value: data[i].value,
                        name: data[i].name,
                    });
                }
                checkInputs.comboWhCd = getComboData2.filter((e) => e.value.substring(0, 5) == 'WH_MM');
                checkInputs.comboMoveWhCd = getComboData2.filter((e) => e.value.substring(0, 5) == 'WH_MM');
                setWhType(getComboData2);
            });

            //품목코드 콤보박스
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10050.GetItemMst, {
                itemCd: 'string',
            }).then((result) => {
                let data = result.data;
                for (let i = 0; i < data.length; i++) {
                    getComboData1.push({
                        id: data[i].itemCd,
                        label: data[i].itemNm,
                    });
                }

                setInputs({
                    ...inputs,
                    copyItemList: [...getComboData1],
                });
            });
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode, {
                groupCd: 'string',
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    throw new Error(data);
                } else if (data.type === '데이터가 없습니다.') {
                    throw new Error(data.message);
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getComboData.push({
                            groupCd: data[i].GroupCd,
                            name: data[i].Name,
                            value: data[i].Code,
                        });
                    }

                    checkInputs.comboList = getComboData.filter((e) => e.groupCd == 'ITEM_TYPE');
                    checkInputs.comboInwh = getComboData.filter((e) => e.groupCd == 'WH_CD');
                }
            });
            //창고코드
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh, {
                whCd: 'string',
            }).then((result) => {
                let data = result.data;
                getComboData.push({
                    value: '',
                    name: '',
                });
                for (let i = 0; i < data.length; i++) {
                    getComboData.push({
                        value: data[i].value,
                        name: data[i].name,
                    });
                }

                inputs.comboInwh = getComboData.filter((e) => e.value.substring(0, 5) === 'WH_MM');
            });
            //콤보박스
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetProc, {
                processCd: 'string',
            }).then((result) => {
                let data = result.data;
                for (let i = 0; i < data.length; i++) {
                    getComboData.push({
                        value: data[i].value,
                        name: data[i].name,
                    });
                }
                inputs.comboList = getComboData;
            });
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Manufacture.MM10050.GetItem).then(
                (result) => {
                    let data = result.data;
                    if (data === '데이터가 없습니다.') {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    } else if (data.type === 'Error') {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    } else {
                        for (let i = 0; i < data.length; i++) {
                            getRowData.push({
                                plantNm: data[i].plantNm,
                                itemCd: data[i].itemCd,
                                itemNm: data[i].itemNm,
                                itemType: data[i].itemType,
                                itemBomYn: data[i].itemBomYn,
                                createId: userInfo.userId,
                                updateId: userInfo.userId,
                                itemStdAmt: data[i].itemStdAmt,
                                lCatego: data[i].lCatego,
                            });
                        }
                        setRowData(Commons.InsertNumber(getRowData));
                    }
                }
            );
        } catch (e) {
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    //BOM 조회
    const SearchItemBomLogic = async (_itemCd) => {
        Dialog.ProgressBar(true);
        let getLanData = [];
        let getRowData = [];
        let totalbomAmt = null;

        try {
            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);
            await Commons.Axios('post', Global.serverUrls.useUrl + Global.urls.logic.Manufacture.MM10050.GetItemBom, {
                itemCd: _itemCd,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setRowData1([]);
                    setBomStdAmt('');
                } else if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setRowData1([]);
                    setBomStdAmt('');
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getRowData.push({
                            plantNm: data[i].plantNm,
                            plantCd: data[i].plantCd,
                            bomItemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            orSeq: data[i].orSeq,
                            itemType: data[i].itemType,
                            itemTypeNm: data[i].itemTypeNm,
                            remark: data[i].remark,
                            itemStdAmt: parseFloat(data[i].itemStdAmt).toFixed(2),
                            whNm: data[i].whNm,
                            bomItemUseage: data[i].bomItemUseage,
                            totalAmt: data[i].totalAmt,
                            updateId: data[i].updateId,
                            updateDate: data[i].updateDate,
                            createId: data[i].createId,
                            createDate: data[i].createDate,
                        });
                        setInputs({
                            ...inputs,
                            comboValue: data[i].processCd,
                        });
                    }
                    for (let i = 0; i < data.length; i++) {
                        totalbomAmt += data[i].totalAmt;
                    }
                    setBomStdAmt(totalbomAmt);

                    setRowData1(Commons.InsertNumber(getRowData));
                }
            });
        } catch (e) {
            console.log(e);
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //복사
    const Copy = async (_itemCd) => {
        Dialog.ProgressBar(true);
        let getLanData = [];
        let getRowData = [];
        let totalbomAmt = null;

        try {
            if (!selectedRowData || selectedRowData == undefined || selectedRowData == null) {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: lanData.filter((f) => f.lanId === 'Snack_SelectData' && f.lanType === 'SNACK')[0].lanName, //데이터를 선택하세요.
                });
                return false;
            } else if (inputs.copyItemCd == null || inputs.copyItemCd == undefined || inputs.copyItemCd == '') {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: lanData.filter((f) => f.lanId === 'Snack_SelectItemShip' && f.lanType === 'SNACK')[0]
                        .lanName, //데이터를 선택하세요.
                });
                return false;
            }
            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);
            await Commons.Axios('post', Global.serverUrls.useUrl + Global.urls.logic.Manufacture.MM10050.GetItemBom, {
                itemCd: inputs.copyItemCd,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                } else if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getRowData.push({
                            bomItemUseage: data[i].bomItemUseage,
                            createId: data[i].createId,
                            bomItemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            itemStdAmt: data[i].itemStdAmt,
                            itemType: data[i].itemType,
                            itemTypeNm: data[i].itemTypeNm,
                            plantNm: data[i].plantNm,
                            totalAmt: data[i].totalAmt,
                            updateId: data[i].updateId,
                            whNm: data[i].whNm,
                            whCd: data[i].whCd,
                        });
                    }
                    setRowData1(Commons.InsertNumber(getRowData));
                }
            });
        } catch (e) {
            console.log(e);
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    const SaveConfirm = (_type) => {
        Dialog.Confirm(
            lanData.filter((f) => f.lanId === 'Dia_Title_Save' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Message_Save' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Btn_Confirm' && f.lanType === 'DIALOG')[0].lanName,
            () => {
                SaveLogic();
            }
        );
    };

    const SaveLogic = async () => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        let updateData = Commons.Deduplication(changedRowData1);
        let getData = [];
        let salesOrders = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            for (let i = 0; i < rowData1.length; i++) {
                if (!rowData1[i].bomItemUseage) {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter(
                            (f) => f.lanId === 'Snack_CheckBomItemUseage' && f.lanType === 'SNACK'
                        )[0].lanName,
                    });
                    return false;
                }
            }
            for (let i = 0; i < rowData1.length; i++) {
                getData.push({
                    whCd: rowData1[i].whCd,
                    plantCd: rowData1[i].plantCd ? rowData1[i].plantCd : checkPlantCd,
                    itemCd: saveItemCd,
                    bomItemCd: !rowData1[i].bomItemCd ? '' : rowData1[i].bomItemCd,
                    itemType: rowData1[i].itemType,
                    itemStdAmt: rowData1[i].itemStdAmt,
                    bomItemUseage: rowData1[i].bomItemUseage,
                    lossRate: 0,
                    remark: rowData1[i].remark,
                    createId: userInfo.userId,
                    createDate: Commons.DateStrChange(new Date()),
                    updateId: userInfo.userId,
                    updateDate: Commons.DateStrChange(new Date()),
                });
            }

            await Commons.Axios(
                'post1',
                Global.serverUrls.useUrl + Global.urls.logic.Manufacture.MM10050.CreateBom,
                getData
            ).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    setSnackbars({
                        toggle: true,
                        typ: 'error',
                        message: data,
                    });
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Save' && f.lanType === 'SNACK')[0].lanName,
                    });
                    SearchItemBomLogic(saveItemCd);
                    setChangedRowData1([]);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    const DeleteConfirm = (_type) => {
        Dialog.Confirm(
            lanData.filter((f) => f.lanId === 'Dia_Title_Delete' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Message_Delete' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Btn_Confirm' && f.lanType === 'DIALOG')[0].lanName,
            () => {
                DeleteLogic();
            }
        );
    };

    const DeleteLogic = async () => {
        Dialog.ProgressBar(true);
        let userInfo = {};
        let deleteData = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            for (let i = 0; i < selectedRowData.length; i++) {
                deleteData.push({
                    plantCd: checkPlantCd,
                    itemCd: saveItemCd,
                    bomItemCd: selectedRowData[i].bomItemCd,
                });
            }
            await Commons.Axios(
                'post',
                Global.serverUrls.useUrl + Global.urls.logic.Manufacture.MM10050.DeleteBom,
                deleteData
            ).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    setSnackbars({
                        toggle: true,
                        type: 'error',
                        message: data,
                    });
                } else {
                    SearchItemBomLogic(saveItemCd);
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Delete' && f.lanType === 'SNACK')[0].lanName,
                    });
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    const GetItemList = async (_value) => {
        Dialog.ProgressBar(true);
        let getLanData = [];
        let getRowData = [];

        try {
            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetStockList, {
                // plantCd: checkPlantCd,
                value: _value === '' ? 'string' : _value,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setAuthGroupGridRowData([]);
                } else if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setAuthGroupGridRowData([]);
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getRowData.push({
                            plantCd: data[i].plantCd,
                            plantNm: data[i].plantNm,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            itemStd: data[i].itemStd,
                            itemFormula: data[i].itemFormula,
                            soItemAmt: data[i].stockQty * data[i].itemStdAmt,
                            itemType: data[i].itemType,
                            whNm: data[i].whCd,
                            whCd: data[i].whCd2,
                            itemUnit: data[i].itemUnit,
                            itemStdAmt: data[i].itemVatYn === 'N' ? data[i].itemStdAmt : data[i].itemStdAmt * 1.1,
                            stockQty: data[i].stockQty,
                            stockAddQty: Commons.splitReserveFun(
                                data[i].stockQty,
                                data[i].itemFormula ? data[i].itemFormula : 1
                            ),
                        });
                    }
                    // setAuthGroupGridRowData(
                    //   getRowData.filter((x) => x.plantCd == checkPlantCd)
                    // );
                    setAuthGroupGridRowData(getRowData);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    const GetItemList2 = async (_itemType, _value) => {
        Dialog.ProgressBar(true);
        let getLanData = [];
        let getRowData = [];

        try {
            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList3, {
                plantCd: 'P100',
                itemType: _itemType === '' ? 'string' : _itemType,
                value: _value === '' ? 'string' : _value,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setAuthGroupGridRowData([]);
                } else if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setAuthGroupGridRowData([]);
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getRowData.push({
                            plantCd: data[i].plantCd,
                            plantNm: data[i].plantNm,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            itemStd: data[i].itemStd,
                            itemFormula: data[i].itemFormula,
                            soItemAmt: data[i].stockQty * data[i].itemStdAmt,
                            itemType: data[i].itemType,
                            itemTypeNm: data[i].itemTypeNm,
                            whNm: data[i].whCd,
                            whCd: data[i].whCd2,
                            itemUnit: data[i].itemUnit,
                            itemUnitNm: data[i].itemUnitNm,
                            itemStdAmt: data[i].itemVatYn === 'N' ? data[i].itemStdAmt : data[i].itemStdAmt * 1.1,
                            stockQty: data[i].stockQty,
                            stockAddQty: Commons.splitReserveFun(
                                data[i].stockQty,
                                data[i].itemFormula ? data[i].itemFormula : 1
                            ),
                        });
                    }
                    // setAuthGroupGridRowData(
                    //   getRowData.filter((x) => x.plantCd == checkPlantCd)
                    // );
                    setAuthGroupGridRowData1(getRowData);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    const CreateStock = async (_itemCd, _whCd, _plantCd) => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        try {
            // if (!checkInputs.itemCd) {
            //   setSnackbars({
            //     toggle: true,
            //     type: "info",
            //     message: lanData.filter(
            //       (f) => f.lanId === "Snack_ ChoseItem" && f.lanType === "SNACK"
            //     )[0].lanName,
            //   });
            //   return false;
            // } else if (!checkInputs.whCd) {
            //   setSnackbars({
            //     toggle: true,
            //     type: "info",
            //     message: lanData.filter(
            //       (f) => f.lanId === "Snack_ ChoseWh" && f.lanType === "SNACK"
            //     )[0].lanName,
            //   });
            //   return false;
            // }
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            await Commons.Axios('post', Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10030.Create, {
                createId: userInfo.userId,
                itemCd: _itemCd,
                itemQty: 0,
                whCd: _whCd,
                plantCd: _plantCd,
            }).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    throw new Error(data.message);
                } else if (data.type === 'Error') {
                    throw new Error(data.message);
                } else {
                    setCheckInputs({
                        ...checkInputs,
                        itemCd: '',
                        itemQty: 0,
                        itemType: '',
                        plnatCd: '',
                    });
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: '저장되었습니다.',
                    });
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
            setChangedRowData([]);
        }
    };

    const Reset = () => {
        setInputs({
            ...inputs,
            itemCd: '',
            itemNm: '',
            itemType: '',
            itemBomYn: '',
            createId: '',
            updateId: '',
            itemStdAmt: '',
        });
    };

    const StockHelper = async () => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        try {
            if (!checkInputs.itemCd) {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: lanData.filter((f) => f.lanId === 'Snack_ ChoseItem' && f.lanType === 'SNACK')[0].lanName,
                });
                return false;
            } else if (!checkInputs.whCd) {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: lanData.filter((f) => f.lanId === 'Snack_ ChoseWh' && f.lanType === 'SNACK')[0].lanName,
                });
                return false;
            }
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            await Commons.Axios('post', Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10030.Create, {
                createId: userInfo.userId,
                itemCd: checkInputs.itemCd,
                itemQty: checkInputs.itemQty,
                whCd: checkInputs.whCd,
                plantCd: checkInputs.plantCd,
            }).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    throw new Error(data.message);
                } else if (data.type === 'Error') {
                    throw new Error(data.message);
                } else {
                    setCheckInputs({
                        ...checkInputs,
                        itemCd: '',
                        itemQty: 0,
                        itemType: '',
                        plnatCd: '',
                    });
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: '저장되었습니다.',
                    });
                    GetItemList('string');
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
            setChangedRowData([]);
        }
    };

    const GetCommonItemList = async (_value) => {
        Dialog.ProgressBar(true);
        let userInfo = {};
        let deleteData = [];
        let getData = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList2, {
                custCd: 'string',
                plantCd: 'string',
                itemType: checkInputs1.itemType === '' ? 'string' : checkInputs1.itemType,
                value: _value === '' ? 'string' : _value,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'error',
                        message: data,
                    });
                    setAuthGroupGridRowData1([]);
                } else {
                    for (let i = 0; i < data.length; i++) {
                        getData.push({
                            plantCd: data[i].plantCd,
                            plantNm: data[i].plantNm,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            itemStd: data[i].itemStd,
                            itemUnit: data[i].itemUnit,
                            itemUnitNm: data[i].itemUnitNm,
                            itemStdAmt: data[i].itemStdAmt,
                            poItemCost: data[i].poItemCost,
                            itemVatYn: data[i].itemVatYn,
                            itemFormula: data[i].itemFormula,
                            itemTypeNm: data[i].itemTypeNm,
                        });
                    }
                    setAuthGroupGridRowData1(getData);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    return (
        <>
            <Mm10050View
                lanData={lanData}
                rowData={rowData}
                setRowData={setRowData}
                rowData1={rowData1}
                setRowData1={setRowData1}
                setChangedRowData={setChangedRowData}
                setChangedRowData1={setChangedRowData1}
                changedRowData1={changedRowData1}
                selectedRowData={selectedRowData}
                setSelectedRowData={setSelectedRowData}
                inputs={inputs}
                setInputs={setInputs}
                SearchItemBomLogic={SearchItemBomLogic}
                Reset={Reset}
                setBomStdAmt={setBomStdAmt}
                Copy={Copy}
                bomStdAmt={bomStdAmt}
                SaveConfirm={SaveConfirm}
                DeleteConfirm={DeleteConfirm}
                GetItemList={GetItemList}
                GetItemList2={GetItemList2}
                authGroupGridRowData={authGroupGridRowData}
                authGroupGridRowData1={authGroupGridRowData1}
                saveItemCd={saveItemCd}
                setSaveItemCd={setSaveItemCd}
                bomYn={bomYn}
                setBomYn={setBomYn}
                snackbars={snackbars}
                setSnackbars={setSnackbars}
                setCheckPlantCd={setCheckPlantCd}
                setSavePlantCd={setSavePlantCd}
                checkPlantCd={checkPlantCd}
                SearchLogic={SearchLogic}
                StockHelper={StockHelper}
                CreateStock={CreateStock}
                setAuthGroupGridRowData={setAuthGroupGridRowData}
                checkInputs={checkInputs}
                setCheckInputs={setCheckInputs}
                checkInputs1={checkInputs1}
                GetCommonItemList={GetCommonItemList}
                whType={whType}
                setCheckInputs1={setCheckInputs1}
            />
            {snackbars.toggle && <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />}
        </>
    );
}

export default MM10050;
